import { reducers } from './reducers';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { SapConfigurationState } from './types';

export const initialState: SapConfigurationState = {
  isLoading: false,
  data: null,
  error: null,
};

const slice = createSlice({
  name: 'sapConfiguration',
  initialState,
  reducers,
});

export const { actions: sapConfigurationActions } = slice;
export const { reducer: sapConfigurationReducer } = slice;
